import { getFormValues } from 'redux-form'
import { createSelector } from 'reselect'
import { ReservationFormFieldVisibility } from '../../../containers/Form/CreateReservation/withReduxForm'
import { IStore } from '../../index'
import { getUserSettings } from '../../userObject/selectors/settings'
import { ICreateReservationFormValues } from '../../../containers/Form/CreateReservation/CreateReservation'
import { labels } from '../../../models/Event/eventConfig'
import { EventStatus } from '../../../models/Event'
import { PrepaidType } from '../../../models/Object'
import { getRooms } from './erhaltenZimmer'
import { getUpdateReservationFormEvent } from './events'
import { getModalCreateReservaion } from './getModalOpen'

const updateFormSelector = getFormValues('update_reservation')
const createFormSelector = getFormValues('create_reservation')

export const getUpdateReservationModalStatus = createSelector(
  [getUserSettings, updateFormSelector],
  (settings, form: ICreateReservationFormValues) => {
    if (form && form.reservationStatus && form.prepaymentType) {
      return {
        color: settings.customReservationStatus.colors[form.reservationStatus]
          .rgb()
          .toString(),
        label:
          settings.customReservationStatus.names[form.reservationStatus] ||
          labels.get(
            form.reservationStatus === EventStatus.Advance
              ? Number(form.prepaymentType) === PrepaidType.Advance
              ? form.reservationStatus
              : '3-2'
              : form.reservationStatus,
          ),
      }
    } else if (settings && settings.defaultReservationStatus) {
      return {
        color: settings.customReservationStatus.colors[
          settings.defaultReservationStatus
          ]
          .rgb()
          .toString(),
        label:
          settings.customReservationStatus.names[
            settings.defaultReservationStatus
            ] ||
          labels.get(
            settings.defaultReservationStatus === EventStatus.Advance
              ? Number(settings.defaultPrepaidType) === PrepaidType.Advance
              ? settings.defaultReservationStatus
              : '3-2'
              : settings.defaultReservationStatus,
          ),
      }
    } else return { color: 'white', label: 'placeholder' }
  },
)

export const getCreateReservationModalStatus = createSelector(
  [getUserSettings, createFormSelector],
  (settings, form: ICreateReservationFormValues) => {
    if (form && form.reservationStatus) {
      return {
        color: settings.customReservationStatus.colors[form.reservationStatus]
          .rgb()
          .toString(),
        label:
          settings.customReservationStatus.names[form.reservationStatus] ||
          labels.get(
            form.reservationStatus === EventStatus.Advance
              ? Number(form.prepaymentType) === PrepaidType.Advance
              ? form.reservationStatus
              : '3-2'
              : form.reservationStatus,
          ),
      }
    } else if (settings && settings.defaultReservationStatus) {
      return {
        color: settings.customReservationStatus.colors[
          settings.defaultReservationStatus
          ]
          .rgb()
          .toString(),
        label:
          settings.customReservationStatus.names[
            settings.defaultReservationStatus
            ] ||
          labels.get(
            settings.defaultReservationStatus === EventStatus.Advance
              ? Number(settings.defaultPrepaidType) === PrepaidType.Advance
              ? settings.defaultReservationStatus
              : '3-2'
              : settings.defaultReservationStatus,
          ),
      }
    } else return { color: 'white', label: 'placeholder' }
  },
)

export const getUpdateReservationModalRoom = createSelector(
  [getRooms, getUpdateReservationFormEvent],
  (rooms, event) => rooms.find(room => event && room.id === event.roomId),
)

export const getCreateReservationModalRoom = createSelector(
  [getRooms, getModalCreateReservaion, createFormSelector],
  (rooms, modal, form: ICreateReservationFormValues) => {
    return rooms.find(
      room => room.id === (form && form.roomId ? form.roomId : modal.roomId),
    )
  },
)

export const getCreateReservationFormTotalAdultsCount = createSelector(
  [getCreateReservationModalRoom],
  room => {
    return room ? Number(room.roomSize) + Number(room.additionalBeds) : null
  },
)

export const getUpdateReservationFormTotalAdultsCount = createSelector(
  [getUpdateReservationModalRoom],
  room => {
    return room ? Number(room.roomSize) + Number(room.additionalBeds) : null
  },
)

export const getCreateReservationFormAdultsCount = createSelector(
  [getCreateReservationModalRoom],
  room => {
    return room && Number(room.roomSize) >= 2 ? 2 : 1
  },
)

export function getIsCalculatingPrice(state: IStore) {
  return state.bookingCalendar.reservationModal.calculatingPrice
}

export function getFieldsVisibility(state: IStore) {
  return state.bookingCalendar.reservationModal.fieldVisibility
}

export function getFieldVisibility(
  state: IStore,
  field: keyof ReservationFormFieldVisibility,
): boolean {
  return state.bookingCalendar.reservationModal.fieldVisibility[field]
}

export function getReservationFormVeryCurrentTab(store) {
  return store.bookingCalendar.reservationModal.selectedTab
}
